import React from 'react';
import { isPageInvalid } from 'packages/pages/design/sidebar/variations/utils';
import { Column, ColumnSelect, ListContainer, RowContainer } from './List.styled';
import PageItem from './PageItem';
import { SelectItemCheckbox } from './SelectItemCheckbox';
import useExport from '../hooks/useExport';

const PageList = ({ items }) => {
    const { orderBy, pageIds } = useExport();

    let filteredItems = items.filter((item) => pageIds.includes(item.pageId.toString()));

    if (!filteredItems.length) {
        filteredItems = items;
    }

    if (orderBy === 'name') {
        filteredItems.sort((a, b) => a.name.localeCompare(b.name));
    }

    if (orderBy === 'updated') {
        filteredItems.sort((a, b) => a.displayOrder - b.displayOrder);
    }

    return (
        <ListContainer>
            {filteredItems.map((item) => {
                const isInvalid = isPageInvalid(item);

                return (
                    <RowContainer key={item.variationId} bordered>
                        <ColumnSelect>
                            <SelectItemCheckbox item={item} isDisabled={isInvalid} />
                        </ColumnSelect>
                        <Column>
                            <PageItem {...item} isInvalid={isInvalid} />
                        </Column>
                    </RowContainer>
                );
            })}
        </ListContainer>
    );
};

export default PageList;
